var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',{staticClass:"pt-0"},[_c('pricelist-content')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }